<div class="error-box">
    <div class="error-body text-center">
        <h1 class="error-title text-danger">404</h1>
        <h1 class="text-uppercase error-subtitle text-danger" style="font-size: 40px;font-weight: 600;">PAGE NOT FOUND !
        </h1>

        <br>
        <a routerLink="/login" class="btn btn-danger btn-rounded waves-effect waves-light mb-5">Back to login</a>
    </div>
</div>